/*
 * chat-imagem-modal — clicar na imagem de uma mensagem do chat V3 abre um modal de visualização.
 * Contrato: docs/chat-imagem-modal/02-design/design-v03.md §6 e §9. Estilo: resources/sass/_chat.scss (.modal.chat-img-modal).
 * Markup: <template id="chat-img-modal-tpl"> em resources/views/v3/chat/assets/image-modal-template.blade.php (incluído no main).
 *
 * - Delegação em document: vale para mensagem que chega depois (websocket, "carregar mais", envio, documento do acervo).
 * - Ctrl/⌘/Shift/Alt/botão do meio não são interceptados: o <a target=_blank> continua abrindo nova aba. Sem JS, idem.
 * - O modal nasce do <template> a cada abertura e é removido no hidden.bs.modal. Não usa createModal/showModal: o
 *   backdrop de lá é estático, o conteúdo exige rota e o afterCloseModal apaga .modal órfão (design §2).
 */
const ChatImageModal = function () {

    const LENTO_MS = 8000;
    const ID = 'chat-img-modal';
    const TPL = 'chat-img-modal-tpl';

    let token = 0;          // descarta resposta de tentativa velha (fechou ou tentou de novo)
    let timerLento = null;
    let atual = null;       // { gatilho, balaoId, url, alt }

    // Só http(s). Qualquer outra coisa (javascript:, data:, vazio) vai para "invalida", sem requisição.
    const urlSegura = function (bruta) {
        if (!bruta) return null;
        try {
            const u = new URL(bruta, window.location.href);
            return (u.protocol === 'https:' || u.protocol === 'http:') ? u.href : null;
        } catch (e) {
            return null;
        }
    };

    // Focáveis VISÍVEIS: botão/link de bloco com display:none tem offsetParent null (design §6.3).
    const focaveis = function (m) {
        return Array.prototype.filter.call(m.querySelectorAll('button, a[href]'), function (el) {
            return el.offsetParent !== null;
        });
    };

    const estado = function (e) {
        const m = document.getElementById(ID);
        if (!m) return;
        m.setAttribute('data-estado', e);
        const bloco = {
            carregando: '.chat-img-modal__carregando .chat-img-modal__txt',
            lento: '.chat-img-modal__lento',
            erro: '.chat-img-modal__erro .chat-img-modal__tit',
            invalida: '.chat-img-modal__invalida .chat-img-modal__tit'
        }[e];
        const anuncio = m.querySelector('[data-chat-img-anuncio]');
        if (anuncio) anuncio.textContent = bloco ? m.querySelector(bloco).textContent : '';
    };

    const carregar = function (url) {
        const m = document.getElementById(ID);
        if (!m || !atual) return;
        const t = ++token;
        clearTimeout(timerLento);
        const velha = m.querySelector('.chat-img-modal__img');
        if (velha) velha.remove();
        estado('carregando');
        timerLento = setTimeout(function () {
            if (t === token && m.getAttribute('data-estado') === 'carregando') estado('lento');
        }, LENTO_MS);

        // Elemento NOVO a cada tentativa: reatribuir o mesmo src no mesmo <img> não refaz o pedido.
        const img = new Image();
        img.className = 'chat-img-modal__img';
        img.alt = atual.alt;
        img.onload = function () {
            if (t !== token) return;
            clearTimeout(timerLento);
            if (!img.naturalWidth) { estado('erro'); return; }
            m.querySelector('.chat-img-modal__palco').insertBefore(img, m.querySelector('.chat-img-modal__carregando'));
            estado('ok');
        };
        img.onerror = function () {
            if (t !== token) return;
            clearTimeout(timerLento);
            estado('erro');
        };
        img.src = url;
    };

    const aoTab = function (e) {
        if (e.key !== 'Tab') return;
        const m = e.currentTarget;
        const f = focaveis(m);
        if (!f.length) { e.preventDefault(); return; }
        const i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) {
            e.preventDefault();
            f[f.length - 1].focus();
        } else if (!e.shiftKey && (i === f.length - 1 || i === -1)) {
            e.preventDefault();
            f[0].focus();
        }
    };

    const aoFechar = function () {
        token++;
        clearTimeout(timerLento);
        const m = document.getElementById(ID);
        if (m) {
            $(m).off('.chatImg');
            m.remove();
        }
        // O websocket pode ter trocado o balão (replaceWith, Chats.js) com o modal aberto: aí o gatilho saiu do DOM
        // e o foco vai para o link do balão de mesmo id. Se o balão também sumiu, o foco fica no body.
        let alvo = atual && atual.gatilho && document.contains(atual.gatilho) ? atual.gatilho : null;
        if (!alvo && atual && atual.balaoId) {
            const b = document.getElementById(atual.balaoId);
            alvo = b ? b.querySelector('a.chat-img-open') : null;
        }
        if (alvo) {
            try { alvo.focus({ preventScroll: true }); } catch (err) { alvo.focus(); }
        }
        atual = null;
    };

    const criarModal = function () {
        const tpl = document.getElementById(TPL);
        if (!tpl || !tpl.content) return null;
        document.body.appendChild(tpl.content.cloneNode(true));
        const m = document.getElementById(ID);
        if (!m) return null;
        $(m).on('shown.bs.modal.chatImg', function () {
            const x = m.querySelector('.chat-img-modal__fechar');
            if (x) x.focus();
        });
        $(m).on('hidden.bs.modal.chatImg', aoFechar);
        m.addEventListener('keydown', aoTab);
        m.querySelector('.chat-img-modal__tentar').addEventListener('click', function () {
            if (atual && atual.url) carregar(atual.url);
        });
        return m;
    };

    // Devolve false quando não deu para abrir (sem molde na página, sem plugin de modal): o clique segue nativo.
    const abrir = function (a) {
        if (!document.getElementById(TPL) || typeof $.fn.modal !== 'function') return false;

        // Tooltip de erro do balão (z 1070) ficaria por cima do modal. O guard do BS 4.5.2 torna o 'hide' inofensivo em
        // balão que nunca foi inicializado (mensagem que chegou por websocket).
        const tip = a.closest('[data-toggle="tooltip"]');
        if (tip && $.fn.tooltip) $(tip).tooltip('hide');

        const balao = a.closest('[data-message_id]');
        const img = a.querySelector('img');
        const autor = a.getAttribute('data-chat-img-autor') || '';
        const hora = a.getAttribute('data-chat-img-hora') || '';
        const url = urlSegura(a.getAttribute('href'));
        atual = { gatilho: a, balaoId: balao ? balao.id : null, url: url, alt: img ? img.alt : '' };

        const m = criarModal();
        if (!m) { atual = null; return false; }

        // textContent / propriedade: autor é dado do usuário, URL é dado externo.
        m.querySelector('.chat-img-modal__meta').textContent = [autor, hora].filter(Boolean).join(' · ');
        m.querySelector('.chat-img-modal__original').href = url || '#';
        if (!url) estado('invalida');           // ANTES do show: o rodapé já nasce oculto e nenhuma requisição sai

        $(m).modal({ backdrop: true, keyboard: true, focus: true, show: true });
        $('.modal-backdrop').last().addClass('bg-backdrop-dark');   // mesmo padrão de app.js (showModal)

        if (url) carregar(url);
        return true;
    };

    const aoClicar = function (e) {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) return;   // nova aba nativa
        if (document.getElementById(ID)) { e.preventDefault(); return; }                 // já aberto ou fechando
        if (abrir(this)) e.preventDefault();
    };

    return {
        init: function () {
            $(document).on('click', 'a.chat-img-open', aoClicar);
        }
    };
}();

export default ChatImageModal;
